import { render, staticRenderFns } from "./AcademyParticipantForm.vue?vue&type=template&id=fdf29bca"
import script from "./AcademyParticipantForm.vue?vue&type=script&lang=ts"
export * from "./AcademyParticipantForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports